import React from 'react'
import { Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { FormattedMessage } from 'react-intl'
import Assets from 'app/configs/assetConfigs'
import PrimaryButton from 'app/components/buttons/PrimaryButton'
import clsx from 'clsx'
import { Routes } from 'app/services/routeService/routeService'

const useStyles = makeStyles((theme) => ({
  gridEmpty: {
    minHeight: '-webkit-fill-available',
  },
  messageStyle: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#1673b0',
    textAlign: 'center',
  },
  upperCaseText: {
    textTransform: 'uppercase',
  },
}))

export default (props) => {
  const classes = useStyles()
  const { onBackPage, history } = props

  const handleClickBack = (ev) => {
    if (onBackPage) onBackPage()
    else {
      history.push(Routes.notificationTimeline())
    }
  }

  return (
    <Grid
      className={clsx(classes.gridEmpty, 'flex')}
      container
      direction="column"
      justify="center"
      alignItems="center"
    >
      <div className="text-center">
        <img
          className="w-4/6 sm:w-2/6 py-5 mb-10"
          src={Assets.subscriber.errorPermissionIcon}
          alt="ImageSubscriberPermission"
        />

        <div
          className={clsx(classes.messageStyle, classes.upperCaseText, 'mb-10')}
        >
          <FormattedMessage
            id="subscriber.errorPermission.message"
            values={{
              b: (text) => (
                <>
                  <br />
                  {text}
                </>
              ),
            }}
          />
        </div>
      </div>

      <div>
        <PrimaryButton className="w-full h-full p-5" onClick={handleClickBack}>
          <FormattedMessage id="subscriber.errorPermission.btn.backToSubscribers" />
        </PrimaryButton>
      </div>
    </Grid>
  )
}
